import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class ForEachStructuredStorageBaseHelper extends StructuredStorageBaseHelper {
    constructor({ each, ...rest }) {
        super(rest);
        this.each = each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.createIteratorStructuredStorage({ type: this.type }));
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachBase({ each: this.each }));
        if (options.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=ForEachStructuredStorageBaseHelper.js.map
